import { Draft } from "./types";

export const GENERIC_ERROR = "Something went wrong";
export const STATUS_PUBLISHED = "PUBLISHED";
export const TITLE_MAX_LENGTH = 150;
export const DESCRIPTION_MAX_LENGTH = 255;
export const GL_SEARCH_LIMIT = 60;
export const NAME_REQUIRED = "Financial Version Name is required.";

export const EMPTY_DRAFT: Draft = { title: "", description: "", cats: [] };

export const errorMessage = (e: any) =>
  typeof e?.response?.data?.message === "string"
    ? e.response.data.message
    : GENERIC_ERROR;
